module.exports = window.cb.core;